<script setup>
import { ref, computed } from 'vue'
import Icon from './Icon.vue'
import { store } from '@/store/appStore.js'
const logoFailed = ref(false)

// Layout: Cluster Head alone on top, all other non-Admin roles in a 2x3
// grid, Admin alone at the bottom.
const visibleRoles = computed(() => store.ROLES.filter(r => !r.disabled))
const clusterHeadRole = computed(() => visibleRoles.value.find(r => r.id === 'countryManager'))
const adminRole = computed(() => visibleRoles.value.find(r => r.id === 'admin'))
const middleRoles = computed(() => visibleRoles.value.filter(r => r.id !== 'countryManager' && r.id !== 'admin'))
</script>

<template>
  <div class="role-select-screen">
    <div style="position:absolute;top:24px;left:28px;display:flex;align-items:center;gap:8px;">
      <img :src="'/hetero-logo.png'" alt="Hetero" class="brand-logo" v-show="!logoFailed" @error="logoFailed=true" />
      <strong v-show="logoFailed" style="font-family:var(--font-display);color:var(--color-primary-dark);font-size:16px;">Hetero Labs Ltd.</strong>
    </div>
    <div class="role-select-header">
      <span class="eyebrow">Pharmacy First — Hetero Labs Ltd.</span>
      <h1>Who's signing in?</h1>
      <p>This is a click-through prototype. Pick a role to see the modules and data that role would use day to day.</p>
    </div>

    <div class="role-grid-single">
      <button class="card role-card" v-if="clusterHeadRole" @click="store.selectRole(clusterHeadRole.id)">
        <span class="role-icon"><Icon :name="clusterHeadRole.icon" :size="20" /></span>
        <h3>{{ clusterHeadRole.label }}</h3>
        <p>{{ clusterHeadRole.desc }}</p>
      </button>
    </div>

    <div class="role-grid">
      <button class="card role-card" v-for="role in middleRoles" :key="role.id" @click="store.selectRole(role.id)">
        <span class="role-icon"><Icon :name="role.icon" :size="20" /></span>
        <h3>{{ role.label }}</h3>
        <p>{{ role.desc }}</p>
      </button>
    </div>

    <div class="role-grid-single">
      <button class="card role-card" v-if="adminRole" @click="store.selectRole(adminRole.id)">
        <span class="role-icon"><Icon :name="adminRole.icon" :size="20" /></span>
        <h3>{{ adminRole.label }}</h3>
        <p>{{ adminRole.desc }}</p>
      </button>
    </div>
  </div>
</template>
